import * as React from 'react';
import { useParams } from 'react-router-dom';

import useLocalStore from 'hooks/useLocalStore';

import FormReviewPivotTableStore from './FormReviewPivotTableStore';

const FormReviewPivotTableStoreContext =
  React.createContext<FormReviewPivotTableStore | null>(null);

export const FormReviewPivotTableContextProvider = ({
  children,
}: React.PropsWithChildren) => {
  const { id } = useParams();

  const store = useLocalStore(
    () => new FormReviewPivotTableStore({ id: id ? Number(id) : null }),
    [id]
  );

  return (
    <FormReviewPivotTableStoreContext.Provider value={store}>
      {children}
    </FormReviewPivotTableStoreContext.Provider>
  );
};

export const useFormReviewPivotTableStore = () => {
  const context = React.useContext(FormReviewPivotTableStoreContext);

  if (!context) {
    throw new Error('FormReviewPivotTableStoreContext is not provided');
  }

  return context;
};
